export default {"src":"/_next/static/media/3.fb56c265.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};